import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import FactoryIcon from "@mui/icons-material/FactoryOutlined";
import React from "react";
import { MdAddBox } from "react-icons/md";
import MainStockList from "./MainStockList";
import CommonStockInward from "../CommonStockInward";
import { useSelector } from "react-redux";

const MainStockManagement = () => {
  const roles = useSelector((state) => state.auth.user.roles);
  return (
    <>
      {roles.any(["super_admin"]) ? (
        <Box sx={{ display: "flex", flex: 1 }}>
          <ListCreateTab
            mod="Main stock"
            viewIcon={<FactoryIcon />}
            createIcon={<MdAddBox />}
            createChildren={<CommonStockInward mode="super_admin" />}
            listChildren={<MainStockList />}
          />
        </Box>
      ) : (
        <MainStockList />
      )}
    </>
  );
};

export default MainStockManagement;
